module.exports = __webpack_public_path__ + "img/019-trophy.15081b97.png";